import { render, staticRenderFns } from "./tendero-vip.vue?vue&type=template&id=84dfda00&scoped=true&"
import script from "./tendero-vip.vue?vue&type=script&lang=js&"
export * from "./tendero-vip.vue?vue&type=script&lang=js&"
import style0 from "./tendero-vip.vue?vue&type=style&index=0&id=84dfda00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dfda00",
  null
  
)

export default component.exports